/* eslint-disable react/no-unescaped-entities */
import { Container, Row, Col } from "react-grid-system";
import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { MetaDescription } from "@components/MetaDescription";
import theme from "@config/theme";

const DocsHomepage = () => (
  <div data-search-exclude>
    <MetaDescription
      description="Guides, tutorials, and reference documentation for Blues products and
      services."
    />
    <Container className="docs-homepage">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs links={[{ name: "Docs", url: "/docs" }]} />
          <h1>Blues Docs</h1>
          <p>
            Welcome to Blues! We're helping you solve the problem of wireless
            connectivity, once and for all. Join us at{" "}
            <a
              href="https://us02web.zoom.us/webinar/register/3216476209981/WN_WAf_TqxSRiGk_hUIsTSBNA"
              target="_blank"
            >
              Getting Started with Blues and Wireless IoT
            </a>{" "}
            for a guided demo.
          </p>
        </Col>
      </Row>

      <hr />

      <h2 className="docs-heading">
        Get Started with the Notecard and Notehub
      </h2>

      <Row>
        <Col sm={6} lg={4}>
          <div>
            <div className="docs-start-notecard-img">
              <TrackedLink href="/quickstart">
                <img alt="" src={ImgSrc("/images/docs/quickstart.svg")} />
              </TrackedLink>
            </div>
            <div className="docs-start-notecard-info">
              <h4>Quickstart</h4>
              <p>
                Learn the fundamentals of the Notecard API with our interactive,
                browser-based guide.
              </p>
              <TrackedLink href="/quickstart" className="landingLink">
                Learn more
              </TrackedLink>
            </div>
          </div>
        </Col>
        <Col sm={6} lg={4}>
          <div>
            <div className="docs-start-notecard-img">
              <TrackedLink href="/guides-and-tutorials">
                <img
                  alt="Notecard Tutorials"
                  src={ImgSrc("/images/docs/tutorials.svg")}
                />
              </TrackedLink>
            </div>

            <div className="docs-start-notecard-info">
              <h4>Tutorials</h4>
              <p>
                Learn how to program your Notecard from firmware, how to connect
                to cloud services, and more.
              </p>
              <TrackedLink href="/guides-and-tutorials" className="landingLink">
                Learn more
              </TrackedLink>
            </div>
          </div>
        </Col>
        <Col sm={6} lg={4}>
          <div>
            <div className="docs-start-notecard-img">
              <TrackedLink href="/terminal">
                <img
                  alt=""
                  src={ImgSrc("/images/docs/notecard_playground.svg")}
                />
              </TrackedLink>
            </div>
            <div className="docs-start-notecard-info">
              <h4>Terminal</h4>
              <p>Explore the Notecard using a browser-based console.</p>
              <TrackedLink href="/terminal" className="landingLink">
                Learn more
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>

      <hr />

      <h2>Explore Blues Resources</h2>
      <div className="landing-page-link-list">
        <div>
          <img alt="" src={ImgSrc("/images/icons/docs/notecard-guides.svg")} />
          <h4>Notecard Walkthrough</h4>
          <p>
            A comprehensive walkthrough of the various features of the Notecard.
          </p>
          <TrackedLink
            href="/notecard/notecard-walkthrough/"
            className="landingLink"
          >
            Learn more
          </TrackedLink>
        </div>

        <div>
          <img alt="" src={ImgSrc("/images/icons/docs/notehub-guides.svg")} />
          <h4>Notehub Walkthrough</h4>
          <p>
            Use Notehub to manage fleets of devices, visualize device data,
            update device and host firmware, and more.
          </p>
          <TrackedLink href="/notehub" className="landingLink">
            Learn more
          </TrackedLink>
        </div>

        <div>
          <img alt="" src={ImgSrc("/images/icons/docs/reference.svg")} />
          <h4>API Reference</h4>
          <p>
            Detailed reference documentation for the Notecard and Notehub APIs.
          </p>
          <TrackedLink href="/api-reference" className="landingLink">
            Learn more
          </TrackedLink>
        </div>

        <div>
          <img
            alt=""
            src={ImgSrc("/images/icons/docs/firmware-libraries.svg")}
          />
          <h4>Notecard Firmware Libraries</h4>
          <p>
            Explore tools for communicating with the Notecard, firmware
            libraries for major languages, and samples for your favorite
            microcontrollers.
          </p>
          <TrackedLink href="/tools-and-sdks" className="landingLink">
            Learn more
          </TrackedLink>
        </div>
        <div>
          <img
            alt=""
            src={ImgSrc("/images/icons/docs/notecard-solutions.svg")}
          />
          <h4>Datasheets</h4>
          <p>
            Datasheets, design files, and resources for building your own
            Notecarriers.
          </p>
          <TrackedLink href="/datasheets" className="landingLink">
            Learn more
          </TrackedLink>
        </div>
      </div>
      <style jsx>{`
        :global(.landingPage .docs-homepage h2) {
          border-top: none;
          padding-top: 0;
        }
        :global(.landingPage .docs-homepage .docs-heading) {
          margin-bottom: 2rem;
        }

        @media (max-width: ${theme.breakpoints.md}px) {
          .docs-start-notecard-info {
            margin-bottom: 2rem;
          }
        }

        .docs-start-notecard-img img {
          width: 100%;
          /* Adjust for whitespace in the SVGs themselves */
          position: relative;
          left: -6px;
        }

        .docs-start-notecard-info h4 {
          margin-bottom: 0;
        }
      `}</style>
    </Container>
  </div>
);

export default DocsHomepage;
